import React, { useState, useEffect } from "react";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { useDispatch } from "react-redux";
import { addClientData } from "../../../../../data/redux/slice/clientOnboardDataSlice";
import { useSnackbar } from "notistack";
import { validateEmail } from "../../../../../utility/emailValidator";
import RowButton from "../../../../components/ui_comps/RowButton";
function BasicDetails({
  onClickNext,
  onClickBack,
  isAddressRequired = false,
  reduxData,
}) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [address, setAddress] = useState("");

  const dispatch = useDispatch();
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20,
  };

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (
      reduxData?.firstName &&
      reduxData?.lastName &&
      reduxData?.email &&
      reduxData?.mobileNumber
    ) {
      setFirstName(reduxData?.firstName);
      setLastName(reduxData?.lastName);
      setEmail(reduxData?.email);
      setMobileNumber(reduxData?.mobileNumber);
      setAddress(reduxData?.address);
    }
  }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <CustomInput
        value={firstName}
        onChange={(data) => setFirstName(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="First Name"
        validator="name"
        type="input"
        inputStyles={{
          ...containerStyle,
        }}
      />
      <CustomInput
        value={lastName}
        onChange={(data) => setLastName(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Last Name"
        validator="name"
        type="input"
        inputStyles={{
          ...containerStyle,
        }}
      />
      <CustomInput
        value={email}
        onChange={(data) => setEmail(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Email id"
        validator="email"
        type="input"
        inputStyles={{
          ...containerStyle,
        }}
      />

      <div
        style={{
          ...containerStyle,
          backgroundColor: "#F3F3F3",
          display: "flex",
          alignSelf: "center",
          height: 50,
          width: "100%",
          boxShadow: "none",
          outline: "none",
          paddingLeft: 10,
          borderRadius: 5,
          boxSizing: "border-box",
          alignItems: "center",
        }}
      >
        <div
          style={{
            borderRight: "1px solid #D9D9D9",
            padding: "2px 0x",
            paddingRight: "5px",
            fontSize: "14px",
          }}
        >
          +91
        </div>

        <CustomInput
          value={mobileNumber}
          onChange={(data) => setMobileNumber(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Mobile number"
          validator="mobile"
          type="input"
          inputStyles={{
            ...containerStyle,
            marginBottom: "0px",
            width: "80%",
            boxShadow: "none",
            outline: "none",
            border: "none",
          }}
        />
      </div>

      {isAddressRequired && (
        <CustomInput
          value={address}
          onChange={(data) => setAddress(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Address"
          validator="address"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      )}

      <RowButton
        onClickBack={onClickBack}
        onClickNext={() => {
          if (
            firstName !== "" &&
            lastName !== "" &&
            mobileNumber.length === 10 &&
            validateEmail(email)
          ) {
            if (isAddressRequired) {
              if (address === "") {
                enqueueSnackbar("Please enter address", {
                  variant: "error",
                });
                return;
              } else {
                onClickNext({
                  firstName,
                  lastName,
                  mobileNumber,
                  email,
                  address,
                });
              }
            } else onClickNext({ firstName, lastName, mobileNumber, email });
          } else {
            if (firstName === "") {
              enqueueSnackbar("Please enter first name", {
                variant: "error",
              });
            } else if (lastName === "") {
              enqueueSnackbar("Please enter last name", {
                variant: "error",
              });
            } else if (!validateEmail(email)) {
              enqueueSnackbar("Please enter a valid email", {
                variant: "error",
              });
            } else if (mobileNumber.length < 10) {
              enqueueSnackbar("Please enter a valid mobile number", {
                variant: "error",
              });
            }
          }
        }}
      />
    </div>
  );
}

export default BasicDetails;
